<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col cols="auto">
          <h2>Версії</h2>
        </v-col>
        <v-divider vertical />
        <v-col
          cols="auto"
          class="pr-0"
        >
          <AddProductVersion
            class="ma-1"
            :disabled="trackVersions"
            @addVersion="addVersion"
          />
        </v-col>

        <slot name="trackVersions" />
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="filteredVersions"
            :hide-default-footer="filteredVersions.length < 11"
            flat
          >
            <template v-slot:item="{ item }">
              <tr :class="item === versions[0] ? `green lighten-3` : ``">
                <td>{{ item.version }}</td>
                <td>{{ item.releaseDate | date }}</td>
                <td v-html="item.notes" />
                <td @click="removeVersion(item.id)">
                  <v-btn
                    large
                    icon
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import AddProductVersion from "./AddProductVersion.vue";

export default {
  components: {
    AddProductVersion,
  },
  props: ["value", "trackVersions"],
  data: () => ({
    headers: [
      { text: "Версія", align: "left", sortable: false },
      { text: "Дата версії", align: "left", sortable: false },
      { text: "Опис версії", align: "left", sortable: false },
      { text: "", align: "left", sortable: false },
    ],
    versions: [],
  }),
  computed: {
    filteredVersions() {
      return this.versions.sort((a, b) => {
        return new Date(b.releaseDate) - new Date(a.releaseDate);
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.versions = this.value;
      },
      immediate: true,
    },
  },
  methods: {
    addVersion(version) {
      this.$emit("add", version);
    },
    removeVersion(versionId) {
      this.$emit("remove", versionId);
    },
  },
};
</script>
